import type { NextPage } from 'next';
import { useState } from 'react';

import type { Winner } from '@src/@types/ozonPrizeWinners';
import {
  OctoberPrizeDrawBanner,
  OctoberPrizeDrawHistories,
  OctoberPrizeDrawPrizeWinners,
} from '@src/components/OctoberPrizeDraw';
import { OctoberPrizeResult } from '@src/components/OctoberPrizeDraw/OctoberPrizeResult';
import { PageHead } from '@src/components/PageHead';
import { Layout } from 'app/Layout';

const PAGE_TITLE = 'Розыгрыш Ozon';

export const OctoberPrizeDrawPage: NextPage = () => {
  const [currentWinner, setCurrentWinner] = useState<Winner | null>(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  return (
    <Layout>
      <PageHead title={PAGE_TITLE} />
      <OctoberPrizeDrawBanner setCurrentWinner={setCurrentWinner} setIsSubmitted={setIsSubmitted} />
      {isSubmitted ? (
        <OctoberPrizeResult currentWinner={currentWinner} />
      ) : (
        <>
          <OctoberPrizeDrawPrizeWinners />
          <OctoberPrizeDrawHistories />
        </>
      )}
    </Layout>
  );
};
